import { api } from "@/lib/api";

// Public (all users): Founder-editable Additional Information + FAQ for Palvelumme.
export async function fetchPublicContent() {
  const { data } = await api.get("/content/public");
  return data.content || { additionalInfo: [], faq: [] };
}

// Founder-only: full editable content document.
export async function fetchAdminContent() {
  const { data } = await api.get("/content/admin");
  return data.content || { additionalInfo: [], faq: [] };
}

export async function updateContent(payload) {
  const { data } = await api.put("/content/admin", payload);
  return data.content;
}

// Founder-only: draft translations of Finnish source strings into targets.
// Returns { en: [...], sv: [...] } aligned to the input `texts` order.
export async function translateTexts(texts, targets = ["en", "sv"]) {
  const { data } = await api.post("/content/admin/translate", { texts, targets });
  return data.translations || {};
}
